<template>
  <div class="bookDetail" :class="ticketClass">
    <BaseHeader :title="pageName" :pageOrder="pageOrder" :backNumber="-2" />

    <template v-if="bookList.length">
      <BoardingPassTicket
        :bookList="bookList"
        :cancelable="$route.params.cancelable"
        :userInfo="userInfo"
        v-model:nowPageOrder="nowPageOrder"
        @openMapInfo="$emit('openMapInfo', $event)"
      />
    </template>
    <NoneTicket v-else class="container_wrap" />
  </div>
</template>

<script>
import { ref, onBeforeUnmount, computed } from "vue";
import { useStore } from "vuex";
import BaseHeader from "@/components/Base/BaseHeader.vue";
import NoneTicket from "@/components/BookDetail/NoneTicket.vue";
import BoardingPassTicket from "@/components/BookDetail/BoardingPassTicket.vue";

export default {
  name: "BookDetail",

  components: {
    BaseHeader,
    NoneTicket,
    BoardingPassTicket,
  },

  props: {
    page: {
      type: String,
    },
    pageName: {
      type: String,
    },
  },

  setup() {
    const store = useStore();
    const serviceTypeCode = computed(
      () => store.state.common.serviceInfo.serviceTypeCode
    );
    // contentProps에 theme값이 boarding_pass면 BoardingPassTicket 화면을 노출 theme 값이 없거나 boarding_pass면 NewTicket 화면을 노출
    // ticketTheme 값과 상관없이 모든 서비스에 BoardingPassTicket 화면을 노출(25.09.24)
    // const ticketTheme = computed(
    //   () => store.state.common.serviceInfo.contentProps?.pages?.ticket?.theme
    // );
    const bookList = computed(() => store.state.book.bookList);
    const nowPageOrder = ref(1);
    const pageOrder = computed(() => {
      if (!bookList.value.length) {
        return "";
      }
      if (serviceTypeCode.value === "PGT-HOLIDA") {
        let bookLines = [];
        bookList.value.forEach((bookInfo) => {
          bookLines = [...bookLines, ...bookInfo.lines];
        });
        return `${nowPageOrder.value}/${bookLines.length}`;
      } else {
        // 티켓을 명절버스와 동일하게 바꾸면서 아래와 같이 수정함
        let bookLines = [];
        bookList.value.forEach((bookInfo) => {
          bookLines = [...bookLines, ...bookInfo.lines];
        });
        return `${nowPageOrder.value}/${bookLines.length}`;
      }
      // return `${nowPageOrder.value}/${bookList.value.length}`;
    });
    const ticketClass = computed(() => {
      // ticket => new-ticket으로 변경, new-ticket => boarding-pass-ticket으로 변경(25.09.24)
      return bookList.value.length ? "boarding-pass-ticket" : "empty";
      // return ticketTheme.value === "boarding_pass"
      //   ? "boarding-pass-ticket"
      //   : "new-ticket";
    });
    // emit('update-layout', true);

    const userInfo = computed(() =>
      serviceTypeCode.value === "PGT-HOLIDA"
        ? bookList.value[0].member
        : store.state.member.userInfo
    );

    onBeforeUnmount(() => {
      // emit('update-layout', false);
    });

    return {
      bookList,
      nowPageOrder,
      pageOrder,
      ticketClass,
      userInfo,
    };
  },
};
</script>
